import { useServiceBusHealthQuery } from '../../../hooks/admin/useSystemHealth'
import { ServiceBusStatusPanel } from './ServiceBusStatusPanel'
import { DualWritePanel } from './DualWritePanel'
import { ThroughputPanel } from './ThroughputPanel'
import { DeadLetterPanel } from './DeadLetterPanel'

/**
 * Read-only view of the Service Bus dual-run.
 *
 * Read-only is deliberate: the dual-write kill switch is an app setting and a
 * feature-flag row, and flipping either from a dashboard during a rollout is
 * how you get an un-audited change nobody can explain afterwards. Changes go
 * through the runbook.
 *
 * The query lives here rather than on the page shell, matching OverviewTab:
 * switching tabs unmounts this component, which stops the refetch interval
 * instead of leaving it polling behind a hidden tab.
 */
export function ServiceBusTab() {
  const { data, isLoading } = useServiceBusHealthQuery()

  return (
    <div className="space-y-6">
      <p className="text-sm text-gray-600">
        Live status of the Azure Service Bus pipeline running alongside the legacy
        Storage Queue.
      </p>

      <ServiceBusStatusPanel data={data} isLoading={isLoading} />
      <DualWritePanel data={data} isLoading={isLoading} />
      <ThroughputPanel data={data} isLoading={isLoading} />
      <DeadLetterPanel data={data} isLoading={isLoading} />
    </div>
  )
}
